/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Lifecycle status.
 */
export type PlatformStatus = (typeof PlatformStatus)[keyof typeof PlatformStatus];

export const PlatformStatus = {
  active: "active",
  inactive: "inactive",
} as const;
